import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { ToxnotComponent, ToxnotComponentProperties } from '../../core/BaseApplicationComponents/ToxnotComponent';
import { SftpImportConfigurationWorkflow, ImportHierarchyOption, getImportHierarchyOptionDescriptions } from '../../../store/Models/Api/SftpImportModels';

interface LevelsConfigurationInfoSectionLocalProps {
    configData: SftpImportConfigurationWorkflow;
}

type LevelsConfigurationInfoSectionProps = LevelsConfigurationInfoSectionLocalProps & ToxnotComponentProperties;

class LevelsConfigurationInfoSectionComponent extends ToxnotComponent<LevelsConfigurationInfoSectionProps> {
    public render() {
        const { configData, appServices } = this.props;
        const hierarchyOptionDescriptions = getImportHierarchyOptionDescriptions(appServices);

        return (
            <p><strong>{this.localizeString("Hierarchy Representation")}:</strong> {hierarchyOptionDescriptions[configData.importHierarchyOptionType as ImportHierarchyOption] || configData.importHierarchyOptionType}</p>
        );
    }
}

export const LevelsConfigurationInfoSection = connect(
    (state: ApplicationState) => ({ appServices: state.appServices! })
)(LevelsConfigurationInfoSectionComponent);
